'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var LineChart = function (_BaseIcon) {
  (0, _inherits3.default)(LineChart, _BaseIcon);

  function LineChart() {
    (0, _classCallCheck3.default)(this, LineChart);
    return (0, _possibleConstructorReturn3.default)(this, (LineChart.__proto__ || (0, _getPrototypeOf2.default)(LineChart)).apply(this, arguments));
  }

  (0, _createClass3.default)(LineChart, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M6.0311927 10.0906441c0-2.23837432 1.82107708-4.0594514 4.0596771-4.0594514 2.2383744 0 4.0594515 1.82107708 4.0594515 4.0594514 0 2.2383744-1.8210771 4.0594515-4.0594515 4.0594515-2.23860002 0-4.0596771-1.8210771-4.0596771-4.0594515m9.0385818 3.5058386c.6994073-.9914477 1.1117394-2.200233 1.1117394-3.5058386C16.1815139 6.72676334 13.4547506 4 10.0908698 4 6.72721472 4 4 6.72676334 4 10.0906441c0 3.3634294 2.72721472 6.0906442 6.0908698 6.0906442 1.3121505 0 2.5263523-.4161689 3.5205083-1.1218955l4.8213744 4.8218258c.4423486.4421229 1.1329542.4757505 1.5346789.0738.4017248-.4017248.3685487-1.0923303-.0738-1.5344532l-4.8238569-4.8240827z'
        }, this.getPathProps()))
      );
    }
  }]);
  return LineChart;
}(_BaseIcon3.default);
/*eslint-enable */


LineChart.defaultProps = {
  width: 18,
  height: 18,
  viewBox: '3 3 18 18'
};
exports.default = LineChart;
//# sourceMappingURL=MagnifyingGlass.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/MagnifyingGlass.js
// module id = 304
// module chunks = 0